import React, { Fragment } from 'react';

import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';
import classes from './Breadcrumbs.module.scss';
import { usePageConfig } from '../../../hooks/usePageConfig';
import { PageItem } from './PageItem/PageItem';
import { SolutionItem } from './SolutionItem/SolutionItem';

const Breadcrumbs = () => {
  const { breadcrumbs } = usePageConfig();

  if (!breadcrumbs) {
    //We need to render empty div to take space for breadcrumbs even if they are not exist for page
    return <div />;
  }

  return (
    <div className={classes.container}>
      <SolutionItem />
      {breadcrumbs.map((breadcrumb, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={index}>
          <NavigateNextRoundedIcon className={classes.separator} color="tertiary" />
          <PageItem icon={breadcrumb.icon} title={breadcrumb.label} />
        </Fragment>
      ))}
    </div>
  );
};

export { Breadcrumbs };
